module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.closed) ? _c('div', {
    class: {
      notificationTooltip: true, buyButton: _vm.position && _vm.position == 'buyButton', middle: _vm.position && _vm.position == 'middle'
    }
  }, [_c('span', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t(_vm.title))
    }
  }, [_vm._v(" {!  !} ")]), _vm._v(" "), _c('span', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t(_vm.text))
    }
  }, [_vm._v(" {!  !} ")]), _vm._v(" "), _c('div', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "icon-close"
  })])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-887da7c8!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Misc/NotificationTooltip.vue
// module id = 167
// module chunks = 0